<template>
  <div class="room-cbt-add-modal-component">
    <div class="room-cbt-add-modal flex flex-col">
      <div class="room-cbt-add-modal-header px-1">
        <h6>문제집 추가</h6>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="mt-6 flex flex-col gap-4 min-h-0 flex-1 overflow-hidden px-1">
        <div class="flex flex-col gap-2">
          <div class="h-8 flex items-center">
            <p class="font-bold">제목</p>
          </div>
          <GrmTextField v-model="cbtTitle" size="xs" class="w-full" />
        </div>
        <div class="flex flex-col gap-2">
          <div class="h-8 flex items-center">
            <p class="font-bold">문제집</p>
          </div>
          <input type="file" accept=".pdf" id="cbt-file" class="w-full text-xs" @input="onUploadCBTFile" />
        </div>
        <div class="flex flex-col gap-2 min-h-0 flex-1 overflow-y-auto">
          <div class="h-8 flex items-center gap-2">
            <p class="font-bold">문항 수 및 문항별 정답 (최대 {{ cbtMaxAnswerCount }}개)</p>
            <div class="flex items-center gap-1">
              <GrmTextField type="number" v-model="cbtAnswerCount" :min="1" :max="cbtMaxAnswerCount" size="xs" class="w-16" />
              <span class="text-sm">개</span>
            </div>
          </div>
          <div class="p-2 min-h-0 flex-1 overflow-y-auto relative">
            <div v-for="(cbtQuestion, i) in cbtQuestionList"
                 :key="cbtQuestion.questionOrder"
                 class="flex items-center gap-1"
                 :class="i !== 0 && (i+1) % cbtQuestion.answerList.length === 0 && (i+1) !== cbtQuestionList.length ? 'border-b pb-3 mb-3' : ''"
            >
              <span class="w-8 text-sm inline-block">{{ number(i+1) }}.</span>
              <div class="flex items-center gap-0.5">
                <button v-for="(answer, j) in cbtQuestion.answerList"
                        :key="answer.answerOrder"
                        class="w-4 h-4 rounded-full text-xs flex justify-center items-center"
                        :class="answer.correct ? 'bg-black' : 'border'"
                        @click="onChangeAnswer(answer.correct, answer.answerOrder, cbtQuestion)"
                >{{ j+1 }}</button>
              </div>
              <div class="flex items-center text-sm">
                (<GrmTextField type="number" v-model="cbtQuestion.questionScore" :min="1" size="2xs" class="w-10" />
                <span class="text-sm">점)</span>
              </div>
            </div>
          </div>
        </div>
        <GrmBtn @click="onAddCBT">문제집 추가하기</GrmBtn>
      </div>
    </div>

    <div v-if="isLoading" class="fixed inset-0 bg-black bg-opacity-10">
      <GrmLoadingCircle />
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import GrmLoadingCircle from "@/components/Common/loading/GrmLoadingCircle.vue";
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn.vue";
import GrmBtn from "@/components/Common/button/GrmBtn.vue";

export default {
  name: 'RoomCBTCreateModal',
  components: {
    GrmBtn,
    GrmCloseBtn,
    GrmTextField,
    GrmLoadingCircle,
  },
  data() {
    return {
      isLoading: false,
      cbtMaxAnswerCount: 100,
      cbtAnswerCount: 1,
      cbtTitle: '',
      cbtFile: null,
      cbtQuestionList: [
        {
          questionType: 'CHOICE',
          correctAnswerCnt: 0,
          questionOrder: 0,
          questionScore: 1,
          answerList: [
            {
              answerOrder: 0,
              correct: false,
            },
            {
              answerOrder: 1,
              correct: false,
            },
            {
              answerOrder: 2,
              correct: false,
            },
            {
              answerOrder: 3,
              correct: false,
            },
            {
              answerOrder: 4,
              correct: false,
            },
          ]
        }
      ]
    }
  },
  computed: {
    number() {
      return (i) => {
        if (i < 10) return `00${i}`
        if (i < 100) return `0${i}`
        return i
      }
    },
  },
  watch: {
    cbtAnswerCount(count, oldCount) {
      if (count === '') {
        return
      }

      const n = count - this.cbtQuestionList.length
      if (n > 0) {
        for(let i=0; i < n; i++) {
          this.cbtQuestionList.push({
            questionType: 'CHOICE',
            correctAnswerCnt: 0,
            questionOrder: this.cbtQuestionList.length,
            questionScore: 1,
            answerList: [
              {
                answerOrder: 0,
                correct: false,
              },
              {
                answerOrder: 1,
                correct: false,
              },
              {
                answerOrder: 2,
                correct: false,
              },
              {
                answerOrder: 3,
                correct: false,
              },
              {
                answerOrder: 4,
                correct: false,
              },
            ]
          })
        }
      } else {
        this.cbtQuestionList.splice(count)
      }
    }
  },
  methods: {
    ...mapMutations('cbt', [
      'ADD_CBT'
    ]),
    ...mapActions('cbt', [
      'createCBT',
      'getCBTList'
    ]),

    onChangeAnswer(correct, order, question) {
      const n = correct ? -1 : 1

      question.correctAnswerCnt += n
      question.answerList.map(answer => {
        if (answer.answerOrder === order) {
          answer.correct = !answer.correct
        }
      })
    },
    onClose() {
      this.$modal('RoomCBTCreateModal')
    },
    onUploadCBTFile(e) {
      this.cbtFile = e.target.files[0]
    },
    async onAddCBT() {
      try {
        this.isLoading = true

        await this.createCBT({
          cbtTitle: this.cbtTitle,
          groupId: this.$room.groupId,
          roomId: this.$room.roomId,
          multipartFile: this.cbtFile,
          filename: this.cbtFile.name,
          questionList: this.cbtQuestionList
        })

        await this.getCBTList({
          roomId: this.$room.roomId,
          searchText: '',
          page: 1,
          size: 10
        })

        this.onClose()
        this.$alert(this.$t('roomCbt.alert.addCbt'))
      } catch (e) {
        this.$alert(this.$t('roomCbt.alert.failedAddCbt'))
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-add-modal-component {
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  z-index: 4;
  white-space: pre-line;
}
.room-cbt-add-modal {
  position: relative;
  width: 600px;
  height: 80vh;
  padding: 30px 30px 50px 30px;
  border-radius: 12px;
  background-color: white;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}
.room-cbt-add-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>